import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";

const BG = "https://images.pexels.com/photos/9556236/pexels-photo-9556236.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=1200&w=940";
const LAYER = "https://static.prod-images.emergentagent.com/jobs/03845479-68ae-49c1-b5ac-681381ff3f15/images/4a865789ca2a9e8ed50b27213bac4977a74cb7a6ba1cd5a0d84e9ddc37ba9a96.jpeg";

export default function ImmersiveScroll() {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start start", "end end"] });

  const bgScale = useTransform(scrollYProgress, [0, 1], [1.3, 1]);
  const bgY = useTransform(scrollYProgress, [0, 1], ["-10%", "10%"]);
  const overlayOpacity = useTransform(scrollYProgress, [0, 0.5, 1], [0.55, 0.65, 0.8]);

  const line1Opacity = useTransform(scrollYProgress, [0.05, 0.2, 0.35, 0.45], [0, 1, 1, 0]);
  const line1Y = useTransform(scrollYProgress, [0.05, 0.2], [60, 0]);

  const line2Opacity = useTransform(scrollYProgress, [0.45, 0.6, 0.75, 0.85], [0, 1, 1, 0]);
  const line2Y = useTransform(scrollYProgress, [0.45, 0.6], [60, 0]);

  const layerY = useTransform(scrollYProgress, [0, 1], [200, -200]);
  const layerRotate = useTransform(scrollYProgress, [0, 1], [-8, 8]);
  const finalOpacity = useTransform(scrollYProgress, [0.82, 0.95], [0, 1]);

  return (
    <section ref={ref} data-testid="immersive-section" className="relative h-[165vh] bg-footer">
      <div className="sticky top-0 h-[88vh] w-full overflow-hidden">
        {/* Parallax background */}
        <motion.div style={{ scale: bgScale, y: bgY }} className="absolute inset-0">
          <img src={BG} alt="" className="w-full h-full object-cover" />
        </motion.div>
        <motion.div style={{ opacity: overlayOpacity }} className="absolute inset-0 bg-footer" />
        <div className="absolute inset-0 bg-gradient-to-t from-footer via-transparent to-footer/40" />

        {/* Floating layered bottle */}
        <motion.div
          style={{ y: layerY, rotate: layerRotate }}
          className="absolute right-[6%] top-1/2 -translate-y-1/2 hidden md:block w-[26vw] max-w-[320px] aspect-[3/4] overflow-hidden rounded-sm shadow-2xl"
        >
          <img src={LAYER} alt="" className="w-full h-full object-cover" />
          <div className="absolute inset-0 ring-1 ring-inset ring-white/15" />
        </motion.div>

        {/* Progressive text reveals */}
        <div className="relative z-10 h-full flex items-center justify-center px-6">
          <motion.p style={{ opacity: line1Opacity, y: line1Y }} className="absolute max-w-3xl text-center">
            <span className="eyebrow text-mocha mb-6 block">Experiența ORÉLIE</span>
            <span className="font-serif font-light text-4xl sm:text-6xl lg:text-7xl text-cream leading-[1.1]">
              Parfumul este invizibil, dar lasă cea mai puternică amprentă în memorie.
            </span>
          </motion.p>

          <motion.p style={{ opacity: line2Opacity, y: line2Y }} className="absolute max-w-3xl text-center">
            <span className="eyebrow text-mocha mb-6 block">Ritualul olfactiv</span>
            <span className="font-serif font-light text-4xl sm:text-6xl lg:text-7xl text-cream leading-[1.1]">
              Fiecare picătură, o poveste care se dezvăluie pe piele, oră după oră.
            </span>
          </motion.p>

          <motion.div style={{ opacity: finalOpacity }} className="absolute text-center">
            <span className="font-serif italic text-3xl sm:text-4xl text-mocha">ORÉLIE</span>
            <p className="eyebrow text-cream/70 mt-3">Haute Parfumerie · Est. 2014</p>
          </motion.div>
        </div>
      </div>
    </section>
  );
}
